import { FlexGap, StackVertical, useLayout } from '@ukpostbox/frontend-framework';
import React from 'react';
import { MailItemContentType } from '../../Types/MailItemTypes';
import { useMailbox } from '../../../Mailboxes/Providers/NewMailboxProvider';
import { MailItemAssignedMeta } from './MailMetaItems/MailItemAssignedMeta';
import { MailItemTagsMetaBlock, MailItemTagsMetaInline } from './MailMetaItems/MailItemTagsMeta';
import { MailItemNotesMeta } from './MailMetaItems/MailItemNotesMeta';
import { MailItemDateReadMeta } from './MailMetaItems/MailItemDateReadMeta';
import { MailItemPagesScannedMeta } from './MailMetaItems/MailItemPagesScannedMeta';
import { MailItemDimensionsMeta } from './MailMetaItems/MailItemDimensionsMeta';
import { MailItemWeightMeta } from './MailMetaItems/MailItemWeightMeta';
import { MailItemEnclosuresMeta } from './MailMetaItems/MailItemEnclosuresMeta';
import { MailItemIncomingTrackingIdMeta } from './MailMetaItems/MailItemIncomingTrackingIdMeta';
import { MailItemOutgoingTrackingIdMeta } from './MailMetaItems/MailItemOutgoingTrackingIdMeta';
import { MailTypeEnum } from '../../../Mailboxes/Types/MailboxProviderTypes';
import { MailItemMetaSender } from './MailMetaItems/MailItemMetaSender';

function MailItemMeta(props: MailItemContentType) {
	const { isTiny, isSmall, isMedium } = useLayout();

	const { mailItemData } = useMailbox();

	if (!mailItemData) return null;

	return (
		<div
			className='mail-item-meta'
			style={{ insetBlockStart: `calc(${props.mailboxTopBarHeight}px + var(--md-unit))` }}
		>
			{(isTiny || isSmall || isMedium) && <h6 className='pageantry-sub-heading text-center mb-0'>Overview</h6>}

			<StackVertical gap={FlexGap.ExtraSmall}>
				<MailItemMetaSender />
				<MailItemPagesScannedMeta />
				{mailItemData.mailType === MailTypeEnum.Parcel && (
					<>
						<MailItemDimensionsMeta />
						<MailItemWeightMeta />
					</>
				)}
			</StackVertical>

			<hr />

			<StackVertical gap={FlexGap.ExtraSmall}>
				{mailItemData?.mailLocationId !== 7 && (
					<MailItemAssignedMeta
						name={mailItemData?.clientName}
						incomingRecipientName={mailItemData?.incomingRecipientName}
					/>
				)}

				<MailItemDateReadMeta />

				<MailItemEnclosuresMeta />

				<MailItemIncomingTrackingIdMeta />
				<MailItemOutgoingTrackingIdMeta />

				{isTiny || isSmall || isMedium ? (
					<MailItemTagsMetaInline />
				) : (
					<>
						<MailItemTagsMetaBlock />
						<MailItemNotesMeta />
					</>
				)}
			</StackVertical>
		</div>
	);
}

export { MailItemMeta };
